<template>
  <div>
    <div id="0" class="text-xl ml-4 mb-10" v-html="$t('risk_popup.note', {contract: 'Note Purchase Commitment'})"></div>
    <img
      class="fixed top-5 right-5 w-7 cursor-pointer"
      src="@/assets/svg/cross.svg"
      alt="cross"
      @click="closePopup"
    />
    <div 
      v-if="scrollBtn.show"
      v-on:click="scrollToElement(scrollBtn.boxNumber)" 
      class="
        flex  
        fixed
        h-10
        w-auto
        bottom-5
        right-5 
        border-grey-dark
        border-4
        rounded-full
        animate-pulse
        cursor-pointer
        justify-center
        items-center 
        px-3
        z-60
      "
    >
      <img   
        class="w-7 h-7 mr-2"
        src="@/assets/svg/arrows/down_grey_arrow.svg"
      />
      <span class="font-bold text-sm lg:text-xs">
        {{ $t('wording.scroll') }}
      </span>
    </div>
    <div class="npc-doc">
      <!-- POSTING SUPPLEMENT -->
      <div class="npc-page">
        <h1>{{ $t('risk_popup.posting.title') }}</h1>
        <h2>
          {{
            $t('risk_popup.posting.sub_title', {
              date: project.created_at.slice(0, 10),
              campaign: seriesNo,
              om: project.om_date
            })
          }}
        </h2>
        <p>{{ $t('risk_popup.posting.sub_title2', { om: project.om_date }) }}</p>
        <p>{{ $t('risk_popup.posting.sub_title3', { om: project.om_date }) }}</p>
        <p>{{ $t('risk_popup.posting.sub_title4') }}</p>
        <table class="npc-notes">
          <tr><td>{{ $t('risk_popup.posting.id') }}</td><td>{{ seriesNo }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.amount') }}</td><td>${{ dollarFormatting(npcPrincipal) }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.grade') }}</td><td>{{ riskConversion(project.risk) }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.rate') }}</td><td>{{ project.funding_rate.interest_investor }}%</td></tr>
          <tr><td>{{ $t('risk_popup.posting.fee') }}</td><td>{{ project.funding_rate.servicing_fee }}%</td></tr>
          <tr><td>{{ $t('risk_popup.posting.term') }}</td><td>{{ $t('risk_popup.posting.term_months', { months: project.funding_rate.duration_months }) }}</td></tr>
        </table>
        <p>{{ $t('risk_popup.posting.final', { date: project.created_at.slice(0, 10), campaign: seriesNo }) }}</p>
        <table class="npc-borrower">
          <tr><td>{{ $t('risk_popup.posting.borrower.name') }}</td><td>{{ project.promoter.name }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.borrower.incorp') }}</td><td>{{ project.promoter.company_year }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.borrower.type') }}</td><td>{{ project.promoter.entity_type }}</td></tr>
          <tr><td>{{ $t('risk_popup.posting.borrower.industry') }}</td><td>{{ project.promoter.company_industry }}</td></tr>
        </table>
      </div>

      <!-- RISK ACKNOWLEDGEMENT -->
      <div class="npc-page npc-calibri">
        <h1>{{ $t('risk_popup.risk_title') }}</h1>
        <div class="npc-risk">
          <div class="npc-risk-box">
            <div class="npc-risk-body">
              <p class="npc-center npc-bold npc-risk-title">{{ $t('risk_popup.risk_title_low') }}</p>
              <div class="npc-risk-ack" v-html="$t('risk_popup.risk_ack', { amount: amount })"></div>
              <ContractDetailBox
                v-if="!agree.risk"
                :copy="'risk_popup.tips.risk'"
              />
              <div id="1">
                <div id="11" class="npc-risk-sign">
                  <span>{{ $t('risk_popup.purchaser') }}</span>
                  <span v-if="agree.risk">{{ $t('risk_popup.lend_signing.signed') }}</span>
                  <GpButton
                    v-else
                    @click="isOrg ?
                      (sign('risk'), sign('schedule_1', 'retail'), sign('schedule_2', 'retail')) :
                      sign('risk')"
                  >
                    {{ $t('risk_popup.sign') }}
                  </GpButton>
                </div>
                <div class="npc-risk-row">
                  <span>{{ $t('risk_popup.date') }}</span>
                  <span>{{ $t('risk_popup.print_name') }}{{ purchaserName }}</span>
                </div>
              </div>
            </div>
            <div class="npc-risk-foot"></div>
          </div>
          <div class="npc-warning">{{ $t('risk_popup.warning_title') }}</div>
        </div>
        <p
          v-for="(line, i) of paragraphs($t('risk_popup.cancel'))"
          :key="'cancel' + i"
          v-html="line"
        ></p>
        <table class="npc-issuer">
          <tr>
            <td class="npc-bold">{{ $t('risk_popup.contact_issuer') }}:</td>
            <td>
              {{ $t('risk_popup.contact_issuer_name') }}
              <div class="npc-issuer-address">{{ $t('risk_popup.contact_issuer_address') }}</div>
            </td>
          </tr>
          <tr>
            <td class="npc-bold">{{ $t('risk_popup.contact_email') }}</td>
            <td><a class="npc-mail">{{ $t('risk_popup.contact_email_address') }}</a></td>
          </tr>
        </table>
        <div
          v-for="(line, i) of paragraphs('<b>' + $t('risk_popup.notice_title') + '</b>' + $t('risk_popup.notice'))"
          :key="'notice' + i"
          class="npc-p"
          v-html="line"
        ></div>
      </div>

      <template v-if="!isOrg">
        <!-- SCHEDULE 1 -->
        <div v-if="agree.risk" class="npc-page">
          <h1>{{ $t('risk_popup.schedule_one.title') }}</h1>
          <h2>{{ $t('risk_popup.schedule_one.subtitle') }}</h2>
          <p v-html="$t('risk_popup.schedule_one.description')"></p>
          <div class="npc-box npc-calibri">
            <div class="npc-grey">{{ $t('risk_popup.schedule_one.instructions_title') }}</div>
            <div class="npc-box-body" v-html="$t('risk_popup.schedule_one.instructions')"></div>
          </div>

          <ContractDetailBox
            v-if="isEligible && !agree.schedule_1"
            id="2"
            :copy="'risk_popup.tips.schedule_1'"
          />
          <!-- A. eligible -->
          <div class="npc-table">
            <div class="npc-head" v-html="headerHtml($t('risk_popup.schedule_one.eligible.title'))"></div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side" style="grid-row: span 3;"><span>{{ $t('risk_popup.schedule_one.eligible.header') }}</span></div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.eligible.income') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isEligible &&
                  storeData.personal_income >= settings.eligible_personal_income &&
                  storeData.personal_income < settings.accredited_personal_income"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'personal_income')"
              >
                {{ signedLabel('schedule_1', 'personal_income') }}
              </GpButton>
            </div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.eligible.spouse_income') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isEligible &&
                  storeData.personal_income >= settings.eligible_spouse_income &&
                  storeData.personal_income < settings.accredited_spouse_income"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'spouse_income')"
              >
                {{ signedLabel('schedule_1', 'spouse_income') }}
              </GpButton>
            </div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.eligible.net_worth') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isEligible &&
                  storeData.net_worth >= settings.eligible_net_worth &&
                  storeData.net_worth < settings.accredited_net_worth"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'net_worth')"
              >
                {{ signedLabel('schedule_1', 'net_worth') }}
              </GpButton>
            </div>
          </div>

          <ContractDetailBox
            v-if="isAccredited && !agree.schedule_1"
            id="2"
            :copy="'risk_popup.tips.schedule_1'"
          />
          <!-- B. accredited - checks values to narrow choices must match suitability values -->
          <div class="npc-table">
            <div class="npc-head" v-html="headerHtml($t('risk_popup.schedule_one.accredited.title'))"></div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side" style="grid-row: span 4;"><span>{{ $t('risk_popup.schedule_one.accredited.header') }}</span></div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.accredited.income') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isAccredited && storeData.personal_income >= settings.accredited_personal_income"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'personal_income')"
              >
                {{ signedLabel('schedule_1', 'personal_income') }}
              </GpButton>
            </div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.accredited.spouse_income') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isAccredited && storeData.personal_income >= settings.accredited_spouse_income"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'spouse_income')"
              >
                {{ signedLabel('schedule_1', 'spouse_income') }}
              </GpButton>
            </div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.accredited.cash') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isAccredited && storeData.assets_value >= settings.accredited_assets_value"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'assets_value')"
              >
                {{ signedLabel('schedule_1', 'assets_value') }}
              </GpButton>
            </div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_one.accredited.net_worth') }}</div>
            <div class="npc-initials">
              <GpButton
                v-if="isAccredited && storeData.net_worth >= settings.accredited_net_worth"
                id="12"
                desktopWidth="w-full"
                :disabled="!agree.risk || agree.schedule_1"
                @click="sign('schedule_1', 'net_worth')"
              >
                {{ signedLabel('schedule_1', 'net_worth') }}
              </GpButton>
            </div>
          </div>

          <!-- C. family & friends (not signable online) -->
          <div class="npc-table">
            <div class="npc-head npc-center" v-html="$t('risk_popup.schedule_one.family.title')"></div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side" style="grid-row: span 4;"><span>{{ $t('risk_popup.schedule_one.family.header') }}</span></div>
            <div class="npc-cell npc-checks" v-html="$t('risk_popup.schedule_one.family.owner')"></div>
            <div class="npc-initials"></div>
            <div class="npc-cell" v-html="$t('risk_popup.schedule_one.family.family')"></div>
            <div class="npc-initials"></div>
            <div class="npc-cell" v-html="$t('risk_popup.schedule_one.family.friend')"></div>
            <div class="npc-initials"></div>
            <div class="npc-cell" v-html="$t('risk_popup.schedule_one.family.associate')"></div>
            <div class="npc-initials"></div>
          </div>

          <ContractDetailBox
            v-if="isRetail"
            id="2"
            :copy="'risk_popup.tips.not_eligible_npc'"
          />
          <ContractDetailBox
            v-else-if="isPending"
            id="2"
            :copy="'risk_popup.tips.schedule_1_pending'"
          />
          <!-- D. not eligible -->
          <div class="npc-table">
            <div class="npc-head npc-center">{{ $t('risk_popup.schedule_one.not_eligible.title') }}</div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side npc-side-short"><span>{{ $t('risk_popup.schedule_one.not_eligible.header') }}</span></div>
            <div class="npc-cell npc-middle"><span>{{ $t('risk_popup.schedule_one.not_eligible.ack') }}</span></div>
            <div class="npc-initials">
              <div v-if="isRetail || isPending" id="12" class="w-full">
                <GpButton
                  desktopWidth="w-full"
                  :disabled="!agree.risk || agree.schedule_1"
                  @click="sign('schedule_1', 'retail')"
                >
                  {{ signedLabel('schedule_1', 'retail') }}
                </GpButton>
              </div>
            </div>
          </div>
        </div>

        <!-- SCHEDULE 2 -->
        <div v-if="agree.schedule_1" class="npc-page">
          <h1>{{ $t('risk_popup.schedule_two.title') }}</h1>
          <h2>{{ $t('risk_popup.schedule_two.subtitle') }}</h2>
          <p v-html="$t('risk_popup.schedule_two.instructions')"></p>
          <div class="npc-box">
            <div class="npc-grey">{{ $t('risk_popup.schedule_two.section1.title') }}</div>
            <div class="npc-grey">{{ $t('risk_popup.schedule_two.section1.sub_title') }}</div>
            <div class="npc-box-body">{{ $t('risk_popup.schedule_two.description') }}</div>
          </div>

          <ContractDetailBox
            v-if="isEligible && !agree.schedule_2"
            id="3"
            :copy="'risk_popup.tips.schedule_2'"
          />
          <!-- A. eligible -->
          <div class="npc-table">
            <div class="npc-head">{{ $t('risk_popup.schedule_two.eligible.title') }}</div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side" style="grid-row: span 3;"><span>{{ $t('risk_popup.schedule_one.eligible.header') }}</span></div>
            <div class="npc-cell npc-span" v-html="$t('risk_popup.schedule_two.eligible.desc')"></div>
            <div class="npc-cell">{{ $t('risk_popup.schedule_two.eligible.confirm', { amount: amount }) }}</div>
            <div class="npc-initials"></div>
            <div class="npc-cell" v-html="$t('risk_popup.schedule_two.eligible.advice', { amount: amount })"></div>
            <div class="npc-initials">
              <GpButton
                v-if="isEligible"
                id="13"
                desktopWidth="w-full"
                :disabled="!agree.schedule_1 || agree.schedule_2"
                @click="sign('schedule_2', 'eligible')"
              >
                {{ signedLabel('schedule_2', 'eligible') }}
              </GpButton>
            </div>
          </div>

          <ContractDetailBox
            v-if="isAccredited && !agree.schedule_2"
            id="3"
            :copy="'risk_popup.tips.schedule_2'"
          />
          <!-- B. accredited -->
          <div class="npc-table">
            <div class="npc-head" v-html="$t('risk_popup.schedule_two.accredited.title')"></div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side npc-side-short"><span>{{ $t('risk_popup.schedule_one.accredited.header') }}</span></div>
            <div class="npc-cell npc-middle"><span v-html="$t('risk_popup.schedule_two.accredited.ack')"></span></div>
            <div class="npc-initials">
              <GpButton
                v-if="isAccredited"
                id="13"
                desktopWidth="w-full"
                :disabled="!agree.schedule_1 || agree.schedule_2"
                @click="sign('schedule_2', 'accredited')"
              >
                {{ signedLabel('schedule_2', 'accredited') }}
              </GpButton>
            </div>
          </div>

          <!-- C. family & friends (not signable online) -->
          <div class="npc-table">
            <div class="npc-head" v-html="$t('risk_popup.schedule_two.family.title')"></div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side npc-side-short"><span>{{ $t('risk_popup.schedule_one.family.header') }}</span></div>
            <div class="npc-cell npc-middle"><span v-html="$t('risk_popup.schedule_two.family.ack')"></span></div>
            <div class="npc-initials"></div>
          </div>

          <ContractDetailBox
            v-if="isRetail"
            id="3"
            :copy="'risk_popup.tips.schedule_2'"
          />
          <ContractDetailBox
            v-else-if="isPending"
            id="3"
            :copy="'risk_popup.tips.schedule_2_pending'"
          />
          <!-- D. not eligible -->
          <div class="npc-table">
            <div class="npc-head">{{ $t('risk_popup.schedule_two.not_eligible.title') }}</div>
            <div class="npc-head-initials">{{ $t('risk_popup.initials') }}</div>
            <div class="npc-side npc-side-short"><span>{{ $t('risk_popup.schedule_one.not_eligible.header') }}</span></div>
            <div class="npc-cell" v-html="$t('risk_popup.schedule_two.not_eligible.ack', { amount: amount })"></div>
            <div class="npc-initials">
              <GpButton
                v-if="isRetail || isPending"
                id="13"
                desktopWidth="w-full"
                :disabled="!agree.schedule_1 || agree.schedule_2"
                @click="sign('schedule_2', 'retail')"
              >
                {{ signedLabel('schedule_2', 'retail') }}
              </GpButton>
            </div>
          </div>

          <!-- section 2: registrant -->
          <div class="npc-box npc-registrant">
            <div class="npc-grey">{{ $t('risk_popup.schedule_two.section2.title') }}</div>
            <div class="npc-grey">{{ $t('risk_popup.schedule_two.section2.info') }}</div>
            <div>{{ $t('risk_popup.schedule_two.section2.name') }}</div>
            <div>{{ $t('risk_popup.schedule_two.section2.dr') }}</div>
            <div class="npc-split">
              <span>{{ $t('risk_popup.schedule_two.section2.phone') }}</span>
              <span>{{ emailLabel }}<a class="npc-mail">{{ emailAddress }}</a></span>
            </div>
            <div>{{ $t('risk_popup.schedule_two.section2.company') }}</div>
          </div>
          <div class="npc-box npc-registrant">
            <div>{{ $t('risk_popup.schedule_two.section2.date') }}{{ project.note_dates?.campaign_start_date }}</div>
          </div>
        </div>
      </template>

      <!-- SCHEDULE C - FORM OF NOTE (shown once the schedules are signed) -->
      <div v-if="agree.schedule_2" class="npc-page npc-note relative">
        <h1>{{ $t('risk_popup.form_of_note.schedule') }}</h1>
        <h1 class="npc-note-title">{{ $t('risk_popup.form_of_note.title') }}</h1>
        <p class="npc-center">{{ $t('risk_popup.form_of_note.no') }}{{ seriesNo }}</p>
        <p class="npc-center" v-html="$t('risk_popup.form_of_note.gpc')"></p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.holder') }}{{ purchaserName }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.loan') }}{{ seriesNo }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.amount') }}{{ amount }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.total') }}{{ dollarFormatting(npcPrincipal) }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.interest') }}{{ project.funding_rate.interest_investor }}%</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.service') }}{{ project.funding_rate.servicing_fee }}%</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.date') }}{{ project.note_dates?.campaign_start_date }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.maturity') }}{{ project.note_dates?.maturity_date }}</p>
        <p class="npc-field">{{ $t('risk_popup.form_of_note.max_maturity') }}{{ project.note_dates?.max_maturity_date }}</p>
        <p v-html="$t('risk_popup.form_of_note.maturity_extension')"></p>
        <p
          v-for="(line, i) of paragraphs($t('risk_popup.form_of_note.repayment_dates', { date: project.created_at.slice(0, 10), om: project.om_date }))"
          :key="'note' + i"
          :class="{ 'mb-0': line.startsWith('If, on the Initial Maturity Date') }"
          v-html="line"
        ></p>
        <ContractDetailBox
          v-if="agree.schedule_2"
          id="4"
          :copy="'risk_popup.tips.finish'"
        />
      </div>
      <!-- accept button -->
      <GpButton id="14" class="mx-auto" :disabled="!agree.schedule_2 || agree.final" @click="next()">
        {{ $t('risk_popup.confirm') }}
      </GpButton>
    </div>
  </div>
</template>
<script>
import { ref, computed, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import useSecurity from '@/mixins/useSecurity'
import GpButton from '@/components/general/GpButton.vue'
import useGlobalHelpers from '@/mixins/useGlobalHelpers.js'
import ContractDetailBox from '@/components/general/ContractDetailBox.vue'

export default {
  components: {
    GpButton,
    ContractDetailBox
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    project: {
      type: Object,
      default: () => {}
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { dollarFormatting, riskConversion, dateTimeFormatting } =
      useGlobalHelpers()
    const store = useStore()
    const i18n = useI18n({ useScope: 'global' })
    const router = useRouter()
    const error = ref(null)

    const emptyAgree = {
      risk: false,
      schedule_1: false,
      schedule_2: false,
      final: false
    }
    const emptySigned = {
      schedule_1: {
        retail: null,
        eligible: null,
        accredited: null
      },
      schedule_2: {
        retail: null,
        eligible: null,
        accredited: null
      }
    }
    const initialScroll = {
      show: true,
      boxNumber: 1
    }

    const agree = ref({ ...emptyAgree })
    // deep copy: a spread would share the nested schedule objects, so signatures survived closing the popup
    const signed = ref(JSON.parse(JSON.stringify(emptySigned)))
    const scrollBtn = ref({ ...initialScroll })

    const isOrg = computed(() => {
      return props.profile.type == 'company'
    })

    // Same rule as Contract::getNPCData: the greenhouse profile's notes are the full loan, the community's the retail cap
    const npcPrincipal = computed(() => {
      const greenhouse = props.project.greenhouse
      return greenhouse && greenhouse.profile_id !== props.profile.profile_id
        ? greenhouse.retail_cap
        : props.project.crowdlending_value
    })

    const isEligible = computed(() => {
      return props.profile.sub_type === 'eligible'
    })

    const isAccredited = computed(() => {
      return props.profile.sub_type === 'accredited'
    })

    const isRetail = computed(() => {
      return props.profile.sub_type === 'retail'
    })

    const isPending = computed(() => {
      return ['eligible_pending', 'accredited_pending'].includes(props.profile.sub_type)
    })

    const type = computed(() => {
      if (isEligible.value) return 'eligible'
      if (isAccredited.value) return 'accredited'
      else return 'retail'
    })

    const fullName = computed(() => {
      return props.profile.name + ' ' + props.profile.surname
    })

    // the purchaser on the PDF is the company for organisation investors (Contract::getNPCData)
    const purchaserName = computed(() => {
      return isOrg.value ? props.profile.company_name : fullName.value
    })

    // initials as stored on the signed PDF (Contract::getNPCData)
    const initials = computed(() => {
      return (props.profile.name || '').substring(0, 1) + (props.profile.surname || '').substring(0, 1)
    })

    // series number as printed on the PDF (Contract::getNPCData)
    const seriesNo = computed(() => {
      return props.project.id < 4 ? String(props.project.id) : '1000' + props.project.id + '0'
    })

    const signedLabel = (section, reason) => {
      return agree.value[section] && signed.value[section][type.value] === reason ? initials.value : i18n.t('risk_popup.initials')
    }

    // split a translated block on its <br/> runs so each part renders as its own paragraph, like the PDF
    const paragraphs = (html) => {
      return html.split(/(?:\s*<br\s*\/?>\s*)+/).map(line => line.trim()).filter(line => line.length)
    }

    // the PDF sets the trailing "because" of the A and B headers in regular weight
    const headerHtml = (title) => {
      return title.replace(/\s*because:\s*$/, ' <span class="font-normal">because</span>:')
    }

    const emailLabel = computed(() => {
      return i18n.t('risk_popup.schedule_two.section2.email').split(':')[0] + ': '
    })

    const emailAddress = computed(() => {
      return i18n.t('risk_popup.schedule_two.section2.email').split(':').slice(1).join(':').trim()
    })

    const sign = (section, reason = null) => {
      agree.value[section] = true
      if (reason) signed.value[section][type.value] = reason
      scrollBtn.value.show = true
      scrollBtn.value.boxNumber ++
    }
    
    function scrollToElement(boxNumber) {
      const element = document.getElementById(boxNumber)
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      scrollBtn.value.show = false
    }

    const innerWidth = ref(window.innerWidth)
    
    const isMobile = computed(() => {
      return innerWidth.value < 768
    })

    const signature = ref(null)
    const { useSignature } = useSecurity()

    // settings are fetched in onBeforeMount, so the first render can happen before they arrive
    const settings = computed(() => {
      return store.state.general.settings || {}
    })

    const settingsConfig = require('@/config/settings.config.js')

    const storeData = computed(() => {
      return props.profile.suitability
    })

    onBeforeMount(async () => {
      await store.dispatch('setRequestSettings', settingsConfig.toString())
      signature.value = useSignature(props.profile)
      if(isMobile.value) scrollBtn.value.boxNumber = 11
    })

    const closePopup = () => {
      signed.value = JSON.parse(JSON.stringify(emptySigned))
      agree.value = { ...emptyAgree }
      scrollBtn.value = { ...initialScroll }
      router.go(-1)
      store.dispatch('setShowPopup', false)
      document.getElementById('0')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    const next = () => {
      store.dispatch('setSignatures', signed.value)
      store.dispatch('setShowPopup', false)
      const popup = {
        isHidden: true
      }
      store.dispatch('setPopup', popup)
    }

    return {
      next,
      npcPrincipal,
      dateTimeFormatting,
      dollarFormatting,
      riskConversion,
      error,
      agree,
      sign,
      signature,
      settings,
      isOrg,
      isAccredited,
      isEligible,
      isRetail,
      isPending,
      storeData,
      type,
      signed,
      fullName,
      initials,
      purchaserName,
      seriesNo,
      signedLabel,
      paragraphs,
      headerHtml,
      emailLabel,
      emailAddress,
      scrollToElement,
      scrollBtn,
      isMobile,
      closePopup
    }
  }
}
</script>